<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value 
      // year
      select#year.register-form.year(
        :name="validationDateKeyName + '-' + 'year'"
        v-model="_year"
        v-validate="{ required: required }"
        placeholder="年"
        data-vv-as="年"
        :class="{ noinput: (required == true && !_year) }"
      )
        option(v-for="option in yearOptions" :value="option.value") {{ option.label }}
      span 年

      // month
      select#month.register-form.month(
        :name="validationDateKeyName + '-' + 'month'"
        v-model="_month"
        v-validate="{ required: required }"
        placeholder="月"
        data-vv-as="月"
        :class="{ noinput: (required == true && !_month) }"
      )
        option(v-for="option in monthOptions" :value="option.value") {{ option.label }}
      span 月

    .error-messages
      div(v-if="errors.has(validationDateKeyName + '-' + 'year')")
        label.error-message {{ errors.first(validationDateKeyName + '-' + 'year') }}
      div(v-if="errors.has(validationDateKeyName + '-' + 'month')")
        label.error-message {{ errors.first(validationDateKeyName + '-' + 'month') }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 入力要素コンポーネント(年月分割入力)
 *
 * - 年月の分割入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSplitYearMonth extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 項目名 */
  @Prop({ required: true, type: String })
  public keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  public required!: boolean;

  /** veevalidateに渡すバリデーション項目名(date用) */
  @Prop()
  public validationDateKeyName!: string;

  /** 年 */
  @Prop({
    default: () => {
      ("");
    }
  })
  public year!: string;

  /** 年選択肢 */
  @Prop({ required: true })
  public yearOptions!: Array<{ value: number | string; label: string }>;

  /** 月 */
  @Prop({
    default: () => {
      ("");
    }
  })
  public month!: string;

  /** 月選択肢 */
  @Prop({ required: true })
  public monthOptions!: Array<{ value: number | string; label: string }>;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _year(): string {
    if (this.year) {
      return this.year;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _year(value: string) {
    this.$emit("update:year", value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _month(): string {
    if (this.month) {
      return this.month;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _month(value: string) {
    this.$emit("update:month", value);
    return;
  }
}
</script>
